import React from "react";
import { connect } from "react-redux";
import { pick } from "ramda";
import { refreshView as refreshViewAction } from "ra-core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import ReactFileReader from "react-file-reader";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import ExampleUser from "../../statics/ExampleUser.csv";
import {
	List,
	Datagrid,
	TextField,
	CardActions,
	EditButton,
	SelectField,
	CreateButton,
	RefreshButton,
	DateField,
	Filter,
	TextInput,
	SelectInput,
	DateInput,
	ExportButton
} from "react-admin";
import { HOST } from "../../configs/index";
import { typeRole } from "../../constant/TypeRole";
import { betweenDays } from "../../constant/Date";
import uploadService from "../../services/uploadService";
import { SUPERADMIN } from "../../constant/TypeRole";
import { exporter } from "./exporter";


const UserFilter = props => (
	<Filter {...props}>
		<SelectInput label="สิทธิ์" source="role" choices={typeRole} />
		<TextInput source="email_contains" />
		{/* <SelectInput label="จำนวนวันที่ไม่เข้าใช้งานระบบ" source="lastActive" choices={betweenDays} /> */}
		<DateInput alwaysOn source="lastActive_lte" label="วันที่เข้าระบบถึงวันที่"/>
      	<DateInput alwaysOn source="lastActive_gte" label="วันที่เข้าระบบตั้งแต่วันที่"/>
	</Filter>
);

export const UserList = props => (
	<List
		{...props}
		title="user.user"
		bulkActions={false}
		filters={<UserFilter />}
		actions={<UserActions />}
		filterDefaultValues={{ username_ne: "admin" }}
		exporter={exporter}
	>
		<Datagrid>
			<div />
			<TextField source="email" />
			<TextField source="provider" />
			<SelectField source="role._id" choices={typeRole} />
			<DateField label="วันเวลาเข้าใช้งานระบบล่าสุด" source="lastActive" locales="th-TH"
          		options={{ year: "numeric", month: "long", day: "numeric" }}/>
			<EditButton />
		</Datagrid>
	</List>
);


const mapStateToProps = state => ({
});
const enhance = connect(
	mapStateToProps,
	{ refreshView: refreshViewAction }
);
const UserActions = enhance(
	class RoomActions extends React.Component {
		state = {
			loading: false,
			open: false,
			files: null,
		};
		handleOpen = () => this.setState({ open: true });
		handleClose = () =>
			this.setState({ open: false, files: null });
		setLoading = (loading = false) => this.setState({ loading });
		render() {
			const { loading, files } = this.state;
			const {
				resource,
				filters,
				displayedFilters,
				filterValues,
				basePath,
				showFilter,

				currentSort,
				exporter, // you can hide ExportButton if exporter = (null || false)
				permanentFilter,
				total,
			} = this.props;
			const role = localStorage.getItem("role");
			return (
				<CardActions>
					{filters &&
						React.cloneElement(filters, {
							resource,
							showFilter,
							displayedFilters,
							filterValues,
							context: "button"
						})}
					<CreateButton basePath={basePath} />
					<ExportButton
						disabled={total === 0}
						resource={resource}
						sort={currentSort}
						filter={{ ...filterValues, ...permanentFilter }}
						exporter={exporter}
					/>
					<RefreshButton />
					<Button
						onClick={this.handleOpen}
						primary="true"
						style={{ color: "#3f51b5" }}
					>
						Import USER CSV
    			</Button>

					<Modal
						aria-labelledby="simple-modal-title"
						aria-describedby="simple-modal-description"
						open={this.state.open}
					>
						<div
							style={{
								position: "relative",
								backgroundColor: "white",
								padding: "20px",
								borderRadius: "4px",
								width: "70%",
								margin: "0 auto",
								minHeight: "100px",
								top: "20%"
							}}
						>
							<Typography variant="title" id="modal-title">
								Import user by CSV
    					</Typography>
							<Typography variant="subheading" id="simple-modal-description" />
							<div style={{ marginTop: 20 }}>
								<a href={ExampleUser}>Download Example User</a>
							</div>
							<div style={{ marginTop: 30 }}>
								<ReactFileReader
									fileTypes={[".csv"]}
									handleFiles={files => this.setState({ files })}
								>
									<Button variant="raised" component="span">
										Choose file
    							</Button>
									{files &&
										files[0] &&
										files[0].name && (
										<span style={{ marginLeft: 10 }}>{files[0].name}</span>
									)}
								</ReactFileReader>
							</div>
							<div style={{ position: "absolute", bottom: 20, right: 30 }}>
								<Button
									primary="true"
									style={{ color: "red" }}
									onClick={this.handleClose}
								>
									Cancel
    						</Button>
								<Button
									primary="true"
									style={{ color: "#3f51b5" }}
									onClick={() =>
										files
											? importRoom(
												files,
												this.setLoading,
												this.props.refreshView,
												this.handleClose
											)
											: alert("Please select Project & CSV file")
									}
								>
									UPLOAD
    						</Button>
							</div>
						</div>
					</Modal>
					<Loading open={loading} />
				</CardActions>
			);
		}
	}
);

const Loading = ({ ...other }) => (
	<Dialog {...other}>
		<DialogTitle id="simple-dialog-title">Loading...</DialogTitle>
		<div style={{ textAlign: "center", marginBottom: 20, height: 50 }}>
			<CircularProgress />
		</div>
	</Dialog>
);

const importRoom = (files, setLoading, refreshView, closeModal) => {
	setLoading(true);
	uploadService([{ rawFile: files[0] }]).then(res => {
		const token = localStorage.getItem("token");
		const fecthOption = {
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`
			}
		};
		const formData = new FormData();
		formData.append("csv", res.url);
		fecthOption.body = formData;
		fetch(`${HOST}/user`, fecthOption)
			.then(response => response.json())
			.then(responseJson => {
				console.log(responseJson);
				setLoading(false);
				closeModal();
				setTimeout(() => refreshView(), 1000);
				alert(`Success ${responseJson ? responseJson.length || 0 : 0} rows`);
			})
			.catch(error => {
				setLoading(false);
				alert("Error");
			});
	});
};



// WEBPACK FOOTER //
// ./src/components/user/UserList.js